import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

import _ from 'lodash';
import axios from "axios/index";
import swal from 'sweetalert2';

import urls from "../../../../utils/urls";
import Header from '../../../Header/index';
import ProgrammingForm from './ProgrammingForm';
import {ajaxHandler} from "../../../../utils/errors";
import {tokenHeader} from "../../../../utils/headers";
import validators from "../../../../utils/validators";
import translator from "../../../../utils/translations";
import PageNotFound from '../../../../components/PageNotFound/pageNotFound';
import { Spinner } from '../../../../components/Loading/Spinner';
import helpers from '../../../../utils/helpers';
import TripSteps from '../Trip/TripSteps';


class NewTrip extends Component {

    constructor(props) {
        super(props);

        this.state = {
            canUserCreateTrip: helpers.canUserCreateInternalTrip(this.props.user),
            ajaxInProgress: false,
            products: false,
            operation_types: false,
            terminals: false,
            destination_areas: false,
            terminal: '',
            carrier: '',
            truck_plate: '',
            trailer_plate: '',
            driver_name: '',
            driver_doc: '',
            operation_type: '',
            estimated_load_date: '',
            product: '',
            destination_area: '',
            contact: '',
            shell_trip_receipt: '',
            provider_trip_receipt: '',
            business_observations: '',
            trip_type: helpers.trip_type.INTERNAL
        }
    }

    componentDidMount() {
        this._fetchFiltersOptions();
    }

    _fetchFiltersOptions = () => {
        const operation_type = `${urls.API_ROOT}/api/v1/operation_type/`;
        const product = `${urls.API_ROOT}/api/v1/product/`;
        const terminal = `${urls.API_ROOT}/api/v1/terminal/`;
        const areas = `${urls.API_ROOT}/api/v1/destinationarea/`;
        axios.all([
            axios.get(operation_type, tokenHeader()),
            axios.get(terminal, tokenHeader()),
            axios.get(product, tokenHeader()),
            axios.get(areas, tokenHeader()),
        ])
            .then(axios.spread(function (oper, term, prod, area) {
                return {
                    operation_types: oper,
                    products: prod,
                    terminals: term,
                    destinations: area
                }
            }))
            .then((data) => {
                let operation_types = [];
                let operation_types_data = data.operation_types.data;
                Object.keys(operation_types_data).forEach(key => {
                    operation_types.push({
                        id: key, value: operation_types_data[key]
                    });
                });

                this.setState({
                    operation_types,
                    terminals: data.terminals.data,
                    destination_areas: data.destinations.data,
                    products: data.products.data.filter(p => p.trip_type === 'INTERN')
                });
            })
            .catch((error) => ajaxHandler(error));
    };

    _handleInput = (prop, value) => {

        // Custom validations
        if(prop === 'carrier_doc'){
            value = value.replace(/-/g, '');
        }

        let numbers = ['line_number', 'order_volume', 'provider_load_volume'];
        if(numbers.indexOf(prop) > -1){
            value = validators.number(value);
        }

        this.setState({[prop]: value});
    };

    _handleDateChange = (prop, value) => {
        this.setState({[prop]: value });
    };

    _handleSelectChange = (ev) => {
        let target = ev.target;
        this.setState({
            [target.getAttribute('data-state-var')]: target.value
        });
    };

    _submitForm = () => {

        this.setState({ajaxInProgress: true});

        let excludedKeys = ['operation_types', 'products', 'terminals', 'destination_areas', 'canUserCreateTrip', 'ajaxInProgress'];

        let data = _.omit(this.state, excludedKeys);
        Object.keys(data).forEach(key => {
            if (data[key] === '') {
                data[key] = null;
            }
        });

        const NEW_SHIPMENT_URL = `${urls.API_ROOT}/api/v1/trip/`;
        axios.post(`${NEW_SHIPMENT_URL}`, data, tokenHeader())
            .then(this._onSubmitSuccess)
            .catch(this._onSubmitError);

    };

    _onSubmitSuccess = (response) => {
        let trip = response.data;

        swal({
            title: 'Viaje creado',
            html: 'El viaje ingresado ha sido creado correctamente. Espere unos segundos mientras lo redirigimos',
            type: 'success',
            showConfirmButton: false,
            timer: 3000
        });

        setTimeout(() => {
            this.props.history.push(`/trips/${trip.id}`);
        }, 3000);
    };

    _onSubmitError = (error) => {
        this.setState({ajaxInProgress: false});
        try{
            let response = error.response;
            if(response.status === 400){
                let keys = Object.keys(response.data);
                let details = '';
                for(let i in keys){
                    details = `${details} <p><b>${translator.getFieldName(keys[i])}:</b> ${response.data[keys[i]].join(' ')}</p>`;
                }
                let body = `<div class='swal-container'><p>Se han encontrado los siguientes errores: </p>${details}</div>`;
                swal({
                    title: 'No se ha podido crear el viaje',
                    html: body,
                    type: 'error'
                });
            }else{
                ajaxHandler(error);
            }
        }
        catch (e){
            ajaxHandler(error);
        }
    };

    _goBack = () => {

        let excludedKeys = ['operation_types', 'products', 'terminals', 'destination_areas',
            'ajaxInProgress', 'canUserCreateTrip', 'trip_type'
        ];

        let data = _.omit(this.state, excludedKeys);
        let warning = false;
        Object.keys(data).forEach(key => {
            if (data[key] !== '') warning = true
        });

        if(warning){
            swal({
                title: 'Atención',
                html: helpers.texts.editionWarning,
                type: 'warning',
                showConfirmButton: true,
                showCancelButton: true,
                allowOutsideClick: false,
                allowEscapeKey: false,
                confirmButtonText: 'Volver al inicio',
                cancelButtonText: 'Cancelar',
                preConfirm: () => this.props.history.push('/internal-trips'),
                reverseButtons: true
            });
        }else{
            this.props.history.push('/internal-trips')
        }

    };

    render() {

        // Security check
        if(!this.props.user || !this.state.canUserCreateTrip){
            return <PageNotFound />;
        }

        // Waiting for options
        if(!(this.state.destination_areas && this.state.products && this.state.terminals && this.state.operation_types)){
            return (
                <div className={"main-dashboard"}>
                    <Header active={helpers.trip_type.INTERNAL} />
                    <div className={"valign-wrapper w100"} style={{height: '100%', minHeight: '300px'}}>
                        <Spinner />
                    </div>
                </div>

            );
        }

        return (
            <div className={"main-dashboard"}>
                <Header active={helpers.trip_type.INTERNAL} />
                <TripSteps steps={helpers.tripSteps.INTERNAL} currentStep={0} />
                <div className={"trip-section"}>
                    <div className={"trip-section-title"}>1. Información del viaje</div>
                    <ProgrammingForm
                        state={this.state}
                        user={this.props.user}
                        handleInput={this._handleInput}
                        handleDate={this._handleDateChange}
                        handleSelect={this._handleSelectChange}
                    />
                </div>
                <div className={"row center"}>
                    <div className={"col s12"}>
                        <button onClick={this._goBack}
                                className={`btn btn-shell-empty z-depth-0 text-center ${this.state.ajaxInProgress ? 'disabled' : ''}`}>
                            Cancelar
                        </button>
                        <button onClick={this._submitForm}
                                className={`btn btn-shell z-depth-0 text-center ${this.state.ajaxInProgress ? 'disabled' : ''}`}>
                            Guardar
                        </button>
                    </div>
                </div>
            </div>

        );
    }
}


const
    mapStateToProps = (state) => {
        return {
            user: state.user
        }
    };

const
    mapDispatchToProps = (dispatch) => {
        return bindActionCreators({}, dispatch);
    };

export default connect(mapStateToProps, mapDispatchToProps)(NewTrip);



// WEBPACK FOOTER //
// ./src/containers/Dashboard/InternalTrips/newTrip/index.js